import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {deserializeArray} from '@app/serializable';
import {User} from '@app/shared/user.service';
import {Tag} from '@app/tag/models';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export class AutocompleteResults {
    tags: Tag[];
    users: User[];

    constructor(tags, users) {
        this.tags = deserializeArray(Tag, tags);
        this.users = deserializeArray(User, users);
    }
}

@Injectable({
    providedIn: 'root',
})
export class AutocompleteService {
    constructor(private http: HttpClient) {}

    autocomplete(
        query: string,
        categories: string[] = null,
        excludeCategories: string[] = null,
    ): Observable<AutocompleteResults> {
        let url = `/api/autocomplete/?q=${query}`;
        if (categories) {
            url += '&' + categories.map((category) => `c=${category}`).join('&');
        }
        if (excludeCategories) {
            url += '&' + excludeCategories.map((category) => `cx=${category}`).join('&');
        }

        return this.http.get<AutocompleteResults>(url).pipe(
            map((results) => {
                return new AutocompleteResults(results.tags, results.users);
            }),
        );
    }
}
